<template>
    <div class="form-control relative">
      <table class="table-act table-hover border-separate p-4 bg-grey-lighter">
        <thead>
          <tr class="text-sm text-grey font-normal w-full text-center bg-grey-lighter">
            <th scope="col" class="auto text-center">Nom et prénom des fondateurs</th>
            <th scope="col" class="auto text-center">Cin des cofondateurs</th>
            <th scope="col" class="auto text-center">Actions</th>
          </tr>
        </thead>
        <tbody class="w-full p-1">
          <tr
            class="w-full bg-white text-2sm text-grey-darker mb-2"
            v-for="(founder, index) in foundersData" :key="index"
          >
            <td>
              <input
                class="border border-grey rounded w-full p-3 text-grey-darker leading focus:outline-none focus:bg-white"
                :id="name"
                :name="name"
                :type="type"
                :disabled="disabled"
                :value="founder.founderName"
                v-model="founder.founderName"
                @input="updateValue"
              />
            </td>
            <td class="border-left-right">
              <input
                class="border border-grey rounded w-full p-3 text-grey-darker leading focus:outline-none focus:bg-white"
                :id="name"
                :name="name"
                :type="type"      
                :disabled="disabled"
                :value="founder.founderCin"
                v-model="founder.founderCin"
                @input="updateValue"
              />
              
            </td>
            <td>
              <button
                type="button"
                :disabled="disabled"
                class="text-white rounded focus:outline-none focus:shadow-outline transition-all border rounded text-white border-red-darker bg-red-darker hover:text-red-darker hover:bg-white text-base p-3"
                @click="remove(index)"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <button
          type="button"
          :disabled="disabled"
          class="add-act-btn mt-1 text-white rounded focus:outline-none focus:shadow-outline transition-all border rounded text-white border-green-darker bg-green-darker hover:text-green-darker hover:bg-white text-base p-2 py-2 mx-4"
          @click="addMore()"
      >
      <i class="fas fa-plus"></i>
      </button>
    </div>
</template>

<script>
import Input from "@/components/spKit/Input.vue";

export default {
  name: "sp-dynamic-input",
  components: {
    "sp-input": Input,
  },
  props: {
    name: String,
    type: {
      type: String,
      default: "text"
    },
    value: {
      type: Array,
      default: ""    
    },
    disabled: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {  
        foundersData: [
        {
          founderName: "",
          founderCin: "",
        },
      ],  
    };
  },
  created() {
    this.foundersData = this.value || [
      {
        founderName: null,
        founderCin: null,
      },
    ];
  },
  methods: {
    addMore() {
      this.foundersData.push({
        founderName: null,
        founderCin: null
      });
    },
    remove(index) {
      if(index > 0) {
        this.foundersData.splice(index, 1);
      }
    },
    updateValue() {
      this.$emit("input", this.foundersData);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mt-1 {
  margin-top: 1rem;
}
.border-left-right {
  border-right: 0.5px solid #e6e8ed;
  border-left: 0.5px solid #e6e8ed;
}
</style>